import { render, staticRenderFns } from "./machineTranslateManageList.vue?vue&type=template&id=7f82b72a&scoped=true"
import script from "./machineTranslateManageList.vue?vue&type=script&lang=js"
export * from "./machineTranslateManageList.vue?vue&type=script&lang=js"
import style0 from "./machineTranslateManageList.vue?vue&type=style&index=0&id=7f82b72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f82b72a",
  null
  
)

export default component.exports